var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVuesaxOutlineMouseSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "CE0E7F41-68CA-4EA3-AA7E-08BA0D6268F9") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Essetional",
    transform: "translate(-556.000000, -636.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mouse-square",
    transform: "translate(556.000000, 636.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,22.75 C3.57000017,22.75 1.25,20.4299998 1.25,15 L1.25,9 C1.25,3.57000017 3.57000017,1.25 9,1.25 L15,1.25 C20.4299998,1.25 22.75,3.57000017 22.75,9 L22.75,12 C22.75,12.41 22.41,12.75 22,12.75 C21.59,12.75 21.25,12.41 21.25,12 L21.25,9 C21.25,4.38999987 19.6100001,2.75 15,2.75 L9,2.75 C4.38999987,2.75 2.75,4.38999987 2.75,9 L2.75,15 C2.75,19.6100001 4.38999987,21.25 9,21.25 L12,21.25 C12.41,21.25 12.75,21.59 12.75,22 C12.75,22.41 12.41,22.75 12,22.75 L9,22.75 Z",
    id: "Vector",
    fill: "#292D32",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3492332,22.7700052 C15.3392332,22.7600052 14.4992355,22.1400297 14.1992354,21.1700296 L12.3492331,15.220017 C12.0992331,14.400017 12.3092328,13.5200084 12.9192328,12.9300085 C13.5192328,12.3400085 14.3892333,12.1200109 15.1892333,12.3700109 L21.1492357,14.2200171 C22.1092357,14.5200171 22.7392342,15.3600109 22.7492342,16.3700109 C22.7592342,17.3700109 22.1492366,18.2200243 21.1892366,18.5400243 L19.559236,19.0900121 C19.329236,19.1700121 19.1492365,19.3400231 19.0792365,19.5700231 L18.5192351,21.2100077 C18.2092351,22.1600077 17.3692336,22.7700052 16.3692336,22.7700052 C16.3592336,22.7700052 16.3592332,22.7700052 16.3492332,22.7700052 Z M13.9792342,13.9900061 C13.7692342,14.2000061 13.6992356,14.4900145 13.7892356,14.7800145 L15.6392341,20.7300272 C15.7992341,21.2400272 16.2192357,21.2600052 16.3792357,21.2700052 C16.5192357,21.2700052 16.9492353,21.2300065 17.1092353,20.7400064 L17.6692328,19.1000218 C17.8892328,18.4300218 18.4292331,17.9000292 19.0992332,17.6700292 L20.7292376,17.1200109 C21.2292376,16.9600109 21.2592363,16.5200304 21.2592363,16.3900304 C21.2592363,16.2600304 21.2192354,15.8200194 20.7192354,15.6600194 L14.759233,13.8100134 C14.659233,13.7800134 14.579233,13.7700049 14.509233,13.7700049 C14.239233,13.7700049 14.0592342,13.9200061 13.9792342,13.9900061 Z",
    id: "Vector",
    fill: "#292D32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,0 L24,24 L0,24 L0,0 L24,0 Z",
    id: "Vector",
    opacity: 0
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineMouseSquare);
export default __webpack_public_path__ + "static/media/vuesax-outline-mouse-square.4f25b3e3cce15960e83dbdeb90236762.svg";
export { ForwardRef as ReactComponent };